import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { first, filter, map } from 'rxjs/operators';
import { ToolCapaciteService } from '../tool-capacite/tool-capacite.service';

@Injectable()
export class ProprieteGuard implements CanActivate {
  constructor(private readonly _router: Router, private readonly _toolCapaciteService: ToolCapaciteService) {}

  canActivate(): Promise<boolean> {
    return new Promise(resolve => {
      this._toolCapaciteService.isCapacityCompletedAndLoaded$
        .pipe(
          filter(selector => selector.isCapaciteLoaded),
          map(selector => selector.isCapaciteCompleted),
          first()
        )
        .subscribe(isCapacityCompleted => {
          if (!isCapacityCompleted) {
            this._router.navigate(['/propriete/estimation-propriete']);
            resolve(false);
          } else {
            resolve(true);
          }
        });
    });
  }
}
